import { Flex, Heading } from '@chakra-ui/react';
import SettingsBreadcrumb from '../../components/SettingsBreadcrumb';
import GridEdicaoCMS from './GridEdicaoCMS/grid-edicao-cms';
import './edicao-cms.scss';

const EdicaoCms = () => {
  return (
    <Flex
      p="40px" 
      bgColor="#fafafa" 
      direction="column">
      <SettingsBreadcrumb /> 
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Edição Cidade Inteligente
      </Heading>
    <GridEdicaoCMS/>
    </Flex>
    
  );
};

export default EdicaoCms;
